export const MAX_EVENT_NAME_LENGTH = 40;
export const MAX_COMPONENT_LOCATION_LENGTH = 18;
export const MAX_COMPONENT_TEXT_LENGTH = 17;
